/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthActionRouteImport } from './routes/auth/action'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedJobsIndexRouteImport } from './routes/_authenticated/jobs/index'
import { Route as AuthenticatedJobCategoriesIndexRouteImport } from './routes/_authenticated/job-categories/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedCompaniesIndexRouteImport } from './routes/_authenticated/companies/index'
import { Route as AuthenticatedUsersNewRouteImport } from './routes/_authenticated/users/new'
import { Route as AuthenticatedUsersUserIdRouteImport } from './routes/_authenticated/users/$userId'
import { Route as AuthenticatedJobsNewRouteImport } from './routes/_authenticated/jobs/new'
import { Route as AuthenticatedJobsJobIdRouteImport } from './routes/_authenticated/jobs/$jobId'
import { Route as AuthenticatedJobCategoriesCategoryIdRouteImport } from './routes/_authenticated/job-categories/$categoryId'
import { Route as AuthenticatedCompaniesCompanyIdRouteImport } from './routes/_authenticated/companies/$companyId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthActionRoute = AuthActionRouteImport.update({
  id: '/auth/action',
  path: '/auth/action',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedJobsIndexRoute = AuthenticatedJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedJobCategoriesIndexRoute =
  AuthenticatedJobCategoriesIndexRouteImport.update({
    id: '/job-categories/',
    path: '/job-categories/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersNewRoute = AuthenticatedUsersNewRouteImport.update({
  id: '/users/new',
  path: '/users/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersUserIdRoute =
  AuthenticatedUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsNewRoute = AuthenticatedJobsNewRouteImport.update({
  id: '/jobs/new',
  path: '/jobs/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedJobsJobIdRoute = AuthenticatedJobsJobIdRouteImport.update({
  id: '/jobs/$jobId',
  path: '/jobs/$jobId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedJobCategoriesCategoryIdRoute =
  AuthenticatedJobCategoriesCategoryIdRouteImport.update({
    id: '/job-categories/$categoryId',
    path: '/job-categories/$categoryId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesCompanyIdRoute =
  AuthenticatedCompaniesCompanyIdRouteImport.update({
    id: '/companies/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/auth/action': typeof AuthActionRoute
  '/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRoute
  '/job-categories/$categoryId': typeof AuthenticatedJobCategoriesCategoryIdRoute
  '/jobs/$jobId': typeof AuthenticatedJobsJobIdRoute
  '/jobs/new': typeof AuthenticatedJobsNewRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/users/new': typeof AuthenticatedUsersNewRoute
  '/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/job-categories/': typeof AuthenticatedJobCategoriesIndexRoute
  '/jobs/': typeof AuthenticatedJobsIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/auth/action': typeof AuthActionRoute
  '/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRoute
  '/job-categories/$categoryId': typeof AuthenticatedJobCategoriesCategoryIdRoute
  '/jobs/$jobId': typeof AuthenticatedJobsJobIdRoute
  '/jobs/new': typeof AuthenticatedJobsNewRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/users/new': typeof AuthenticatedUsersNewRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/job-categories': typeof AuthenticatedJobCategoriesIndexRoute
  '/jobs': typeof AuthenticatedJobsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/auth/action': typeof AuthActionRoute
  '/_authenticated/companies/$companyId': typeof AuthenticatedCompaniesCompanyIdRoute
  '/_authenticated/job-categories/$categoryId': typeof AuthenticatedJobCategoriesCategoryIdRoute
  '/_authenticated/jobs/$jobId': typeof AuthenticatedJobsJobIdRoute
  '/_authenticated/jobs/new': typeof AuthenticatedJobsNewRoute
  '/_authenticated/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/_authenticated/users/new': typeof AuthenticatedUsersNewRoute
  '/_authenticated/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/job-categories/': typeof AuthenticatedJobCategoriesIndexRoute
  '/_authenticated/jobs/': typeof AuthenticatedJobsIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/auth/action'
    | '/companies/$companyId'
    | '/job-categories/$categoryId'
    | '/jobs/$jobId'
    | '/jobs/new'
    | '/users/$userId'
    | '/users/new'
    | '/companies/'
    | '/dashboard/'
    | '/job-categories/'
    | '/jobs/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/auth/action'
    | '/companies/$companyId'
    | '/job-categories/$categoryId'
    | '/jobs/$jobId'
    | '/jobs/new'
    | '/users/$userId'
    | '/users/new'
    | '/companies'
    | '/dashboard'
    | '/job-categories'
    | '/jobs'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/auth/action'
    | '/_authenticated/companies/$companyId'
    | '/_authenticated/job-categories/$categoryId'
    | '/_authenticated/jobs/$jobId'
    | '/_authenticated/jobs/new'
    | '/_authenticated/users/$userId'
    | '/_authenticated/users/new'
    | '/_authenticated/companies/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/job-categories/'
    | '/_authenticated/jobs/'
    | '/_authenticated/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthActionRoute: typeof AuthActionRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/action': {
      id: '/auth/action'
      path: '/auth/action'
      fullPath: '/auth/action'
      preLoaderRoute: typeof AuthActionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs/': {
      id: '/_authenticated/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof AuthenticatedJobsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/job-categories/': {
      id: '/_authenticated/job-categories/'
      path: '/job-categories'
      fullPath: '/job-categories/'
      preLoaderRoute: typeof AuthenticatedJobCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/': {
      id: '/_authenticated/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthenticatedCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/new': {
      id: '/_authenticated/users/new'
      path: '/users/new'
      fullPath: '/users/new'
      preLoaderRoute: typeof AuthenticatedUsersNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/$userId': {
      id: '/_authenticated/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs/new': {
      id: '/_authenticated/jobs/new'
      path: '/jobs/new'
      fullPath: '/jobs/new'
      preLoaderRoute: typeof AuthenticatedJobsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs/$jobId': {
      id: '/_authenticated/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/jobs/$jobId'
      preLoaderRoute: typeof AuthenticatedJobsJobIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/job-categories/$categoryId': {
      id: '/_authenticated/job-categories/$categoryId'
      path: '/job-categories/$categoryId'
      fullPath: '/job-categories/$categoryId'
      preLoaderRoute: typeof AuthenticatedJobCategoriesCategoryIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/$companyId': {
      id: '/_authenticated/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedCompaniesCompanyIdRoute: typeof AuthenticatedCompaniesCompanyIdRoute
  AuthenticatedJobCategoriesCategoryIdRoute: typeof AuthenticatedJobCategoriesCategoryIdRoute
  AuthenticatedJobsJobIdRoute: typeof AuthenticatedJobsJobIdRoute
  AuthenticatedJobsNewRoute: typeof AuthenticatedJobsNewRoute
  AuthenticatedUsersUserIdRoute: typeof AuthenticatedUsersUserIdRoute
  AuthenticatedUsersNewRoute: typeof AuthenticatedUsersNewRoute
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedJobCategoriesIndexRoute: typeof AuthenticatedJobCategoriesIndexRoute
  AuthenticatedJobsIndexRoute: typeof AuthenticatedJobsIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCompaniesCompanyIdRoute: AuthenticatedCompaniesCompanyIdRoute,
  AuthenticatedJobCategoriesCategoryIdRoute:
    AuthenticatedJobCategoriesCategoryIdRoute,
  AuthenticatedJobsJobIdRoute: AuthenticatedJobsJobIdRoute,
  AuthenticatedJobsNewRoute: AuthenticatedJobsNewRoute,
  AuthenticatedUsersUserIdRoute: AuthenticatedUsersUserIdRoute,
  AuthenticatedUsersNewRoute: AuthenticatedUsersNewRoute,
  AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedJobCategoriesIndexRoute: AuthenticatedJobCategoriesIndexRoute,
  AuthenticatedJobsIndexRoute: AuthenticatedJobsIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthActionRoute: AuthActionRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
